import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import { settingsGiftCardsAndPromotionsPath } from 'lib/urls'

const GiftCardBalanceAction: React.FC = () => (
  <Button
    data-testid="GiftDetails__GiftActions__GiftCardBalance"
    href={settingsGiftCardsAndPromotionsPath}
    size="md"
    variant="tertiary"
  >
    View gift card balance
  </Button>
)

export default GiftCardBalanceAction
